import {
  AfterContentInit,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  input,
  output,
  Output, signal
} from '@angular/core';
import {TranslocoPipe} from '@ngneat/transloco';
import { SvgWrapperComponent } from '../svg-wrapper/svg-wrapper.component';
import { ShowMoreLessComponent } from '../show-more-less/show-more-less.component';
import { Obelisk } from '../../interfaces/exploration.interfaces';
import { getPlatform, navToExternalUrl } from '../../functions/common.functions';

@Component({
    selector: 'app-obelisk-view',
    imports: [SvgWrapperComponent, TranslocoPipe, ShowMoreLessComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './obelisk-view.component.html',
    styleUrl: './obelisk-view.component.scss'
})
export class ObeliskViewComponent implements AfterContentInit {
  obelisk = input.required<Obelisk>();

  obeliskDescription = computed<string[]>(() => {
    if (!this.obelisk()?.description?.length) {
      return [];
    }

    return this.obelisk().description.split('\n');
  });
  hideDownloadIOS = signal(false);
  hideDownloadAndroid = signal(false);

  @Output() hideEvent = new EventEmitter<void>();
  @Output() closeObelisk = new EventEmitter<void>();
  previewImage = output<string>();

  copiedLink = false;

  constructor() {
    switch (getPlatform().toLowerCase()) {
      case 'android':
        this.hideDownloadIOS.set(true);
        break;
      case 'ios':
        this.hideDownloadAndroid.set(true);
        break;
    }
  }

  ngAfterContentInit(): void {
    if (this.obelisk().images.length > 0) {
      setTimeout(() => {
        const swiperEl = document.querySelector('swiper-container') as any;
        swiperEl?.initialize();
      }, 0);
    }
  }

  copyObeliskLink() {
    if (this.copiedLink) {
      return;
    }

    const url =  `https://app.questatlas.world/show-place/${this.obelisk().uuid}`;
    navigator.clipboard.writeText(url).then(() => {
      this.copiedLink = true;

      setTimeout(() => {
        this.copiedLink = false;
      }, 3000);
    });
  }

  protected readonly navToExternalUrl = navToExternalUrl;
}
